import ProductTypeEnum from "../enums/ProductTipeEnum";
var Product = /** @class */ (function () {
    function Product() {
        this._id = "";
        this._name = "";
        this._type = ProductTypeEnum.other;
        this._price = 0;
        this._description = "";
        this._image = "";
        this._thumbnail = "";
        this._stock = 0;
        this._discount = 0;
    }
    Object.defineProperty(Product.prototype, "id", {
        //#region id
        get: function () {
            return this._id;
        },
        set: function (id) {
            this._id = id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "name", {
        //#endregion id
        //#region name
        get: function () {
            return this._name;
        },
        set: function (name) {
            switch (true) {
                case name.length < 3:
                    throw Error("El Nombre debe poseer al menos 3 caracteres.");
                case name.length > 100:
                    throw Error("El Nombre debe poseer como máximo 100 caracteres.");
                default:
                    this._name =
                        name.substring(0, 1).toUpperCase() +
                            name.substring(1, name.length).toLowerCase();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "type", {
        //#endregion name
        //#region type
        get: function () {
            return this._type;
        },
        set: function (type) {
            this._type = type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "price", {
        //#endregion type
        //#region price
        get: function () {
            return this._price;
        },
        set: function (price) {
            if (price <= 0 || isNaN(price)) {
                throw Error("El Precio debe ser mayor a 0.");
            }
            this._price = price;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "description", {
        //#endregion price
        //#region description
        get: function () {
            return this._description;
        },
        set: function (description) {
            switch (true) {
                case description.length < 3:
                    throw Error("La Descripcion debe poseer al menos 3 caracteres.");
                case description.length > 5000:
                    throw Error("El Descripcion debe poseer como máximo 5000 caracteres.");
                default:
                    this._description = description;
            }
            this._description = description;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "image", {
        //#endregion description
        //#region image
        get: function () {
            return this._image;
        },
        set: function (image) {
            this._image = image;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "thumbnail", {
        //#endregion image
        //#region thumbnail
        get: function () {
            return this._thumbnail;
        },
        set: function (thumbnail) {
            this._thumbnail = thumbnail;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "discount", {
        //#endregion thumbnail
        //#region discount
        get: function () {
            return this._discount;
        },
        set: function (discount) {
            if (discount < 0 || isNaN(discount)) {
                throw Error("El descuento debe ser al menos 0%.");
            }
            if (discount > 100) {
                throw Error("El descuento no puede ser superior al 100%.");
            }
            this._discount = discount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Product.prototype, "stock", {
        //#endregion discount
        //#region stock
        get: function () {
            return this._stock;
        },
        set: function (stock) {
            if (stock < 0 || isNaN(stock)) {
                throw Error("El Stock debe ser mayor a 0.");
            }
            this._stock = stock;
        },
        enumerable: false,
        configurable: true
    });
    Product.prototype.increaseStock = function () {
        this._stock++;
    };
    Product.prototype.decreaseStock = function () {
        if (this.stock === 0) {
            throw Error("Éste producto no posee más unidades en stock.");
        }
        this._stock--;
    };
    //#endregion stock
    Product.prototype.getPriceWithDiscount = function () {
        return this._price * (1 - this._discount / 100);
    };
    Product.prototype.create = function (prod) {
        this._id = prod._id;
        this._name = prod._name;
        this._type = prod._type;
        this._price = prod._price;
        this._description = prod._description;
        this._image = prod._image;
        this._thumbnail = prod._thumbnail;
        this._stock = prod._stock;
        this._discount = prod._discount;
    };
    return Product;
}());
export default Product;
